<template>
  <div class="row">
    <div class="col-12">
      <q-card square flat>
        <div
          v-if="Object.keys(personalData).length > 0 && Object.keys(personalData.details).length > 0"
          class="row justify-end q-col-gutter-md"
        >
          <div class="col-12">
            <q-markup-table :separator="separator" square dense :flat="flat" :bordered="bordered">
              <tbody>
                <slot name="tr-top"></slot>
                <tr>
                  <td>{{ $t('Member.IBOid.Text') }}</td>
                  <td class="text-uppercase">
                    {{
                      $helpers.getValue(
                        personalData,
                        'details.ibo_id',
                        $helpers.getValue(personalData, 'details.user.old_member_id', $t('Common.NotAvailable.Text'))
                      )
                    }}
                  </td>
                </tr>
                <tr v-if="$helpers.isSet(personalData, 'details.translated_name', ['notNull', 'notEmpty'])">
                  <td>{{ $ts('td.translatedName') }}</td>
                  <td class="text-uppercase">
                    {{
                      $helpers.getValue(
                        personalData,
                        'details.ibo_name',
                        $helpers.getValue(personalData, 'details.translated_name', $t('Common.NotAvailable.Text'))
                      )
                    }}
                  </td>
                </tr>
                <tr>
                  <td>{{ $t('Member.IBOName.Text') }}</td>
                  <td class="text-uppercase">
                    {{
                      $helpers.getValue(
                        personalData,
                        'details.ibo_name',
                        $helpers.getValue(personalData, 'details.user.name', $t('Common.NotAvailable.Text'))
                      )
                    }}
                  </td>
                </tr>
                <tr>
                  <td>{{ $t('Member.JoinDate.Text') }}</td>
                  <td class="text-uppercase">
                    {{
                      $helpers.getValue(
                        personalData,
                        'details.joined_date',
                        $helpers.getValue(personalData, 'details.join_date', $t('Common.NotAvailable.Text'))
                      )
                    }}
                  </td>
                </tr>
                <tr>
                  <td>{{ $t('Member.ExpiryDate.Text') }}</td>
                  <td class="text-uppercase" :class="isMembershipExpired ? 'text-negative' : 'text-positive'">
                    {{ $helpers.getValue(personalData, 'details.expiry_date', $t('Common.NotAvailable.Text')) }}
                    <q-icon
                      size="sm"
                      :name="isMembershipExpired ? 'sentiment_very_dissatisfied' : 'sentiment_very_satisfied'"
                    ></q-icon>
                  </td>
                </tr>
                <tr>
                  <td>{{ $t('Member.MemberCountry.Text') }}</td>
                  <td class="text-uppercase">
                    {{
                      $helpers.getValue(
                        personalData,
                        'details.country.name',
                        $helpers.getValue(personalData, 'details.country', $t('Common.NotAvailable.Text'))
                      )
                    }}
                  </td>
                </tr>
                <tr v-if="!hideField('MembershipType')">
                  <td>{{ $t('Member.MembershipType.Text') }}</td>
                  <td class="text-uppercase">
                    {{
                      $helpers.getValue(
                        personalData,
                        'details.enrollment_rank.rank_name',
                        $helpers.getValue(personalData, 'details.enrollment_rank', $t('Common.NotAvailable.Text'))
                      )
                    }}
                  </td>
                </tr>
                <tr v-if="!hideField('highestRank')">
                  <td>{{ $t('modules.members.fields.highestRank') }}</td>
                  <td class="text-uppercase">
                    {{
                      $helpers.getValue(
                        personalData,
                        'details.highest_rank.rank_name',
                        $helpers.getValue(personalData, 'details.highest_rank', $t('Common.NotAvailable.Text'))
                      )
                    }}
                  </td>
                </tr>
                <tr
                  v-if="
                    !hideField('effectiveRank') && showSpecialRanks && getMemberRankConfig('effective_rank').display
                  "
                >
                  <td>{{ $t('modules.members.fields.effectiveRank') }}</td>
                  <td class="text-uppercase">
                    {{
                      $helpers.getValue(
                        personalData,
                        'details.effective_rank.rank_name',
                        $helpers.getValue(personalData, 'details.effective_rank', $t('Common.NotAvailable.Text'))
                      )
                    }}
                  </td>
                </tr>
                <tr v-if="showField('memberRank') && showSpecialRanks">
                  <td>{{ $t('modules.members.fields.memberRank') }}</td>
                  <td class="text-uppercase">
                    {{
                      $helpers.getValue(
                        personalData,
                        'details.effective_rank.rank_name',
                        $helpers.getValue(personalData, 'details.effective_rank', $t('Common.NotAvailable.Text'))
                      )
                    }}
                  </td>
                </tr>
                <tr v-if="showField('councilRank')">
                  <td>{{ $t('modules.members.fields.councilRank') }}</td>
                  <td class="text-uppercase">
                    {{ $helpers.getValue(personalData, 'details.council_rank.name', $t('Common.NotAvailable.Text')) }}
                  </td>
                </tr>
                <tr v-if="!hideCumulativePersonalSales">
                  <td>{{ $t('common.terms.cumulativePersonalSales1') }}</td>
                  <td v-if="showField('cumulativePersonalSales1')" class="text-uppercase">
                    {{ $helpers.getValue(personalData, 'details.personal_bv', 0) }}
                  </td>
                  <td v-else class="text-uppercase">
                    {{ $helpers.getValue(personalData, 'details.personal_sales_cv', 0) }}
                  </td>
                </tr>
                <tr v-if="!hideCumulativePersonalSales && showField('cumulativePersonalSales2')">
                  <td>{{ $t('common.terms.cumulativePersonalSales2') }}</td>
                  <td class="text-uppercase">
                    {{ $helpers.getValue(personalData, 'details.personal_sv', 0) }}
                  </td>
                </tr>
                <tr v-if="!hideCumulativePersonalSales && showField('cumulativePersonalSales3')">
                  <td>{{ $t('common.terms.cumulativePersonalSales3') }}</td>
                  <td class="text-uppercase">
                    {{ $helpers.getValue(personalData, 'details.personal_cbp_point', 0) }}
                  </td>
                </tr>
                <tr v-if="showEwalletInfo">
                  <td>{{ $t('wallet.adjustment.label.balance') }}</td>
                  <td class="text-uppercase">
                    {{ currencyLabelByCountry }}
                    {{ $helpers.getValue(personalData, 'ewallet.balance', 0) | formatPriceDouble }}
                  </td>
                </tr>
                <tr v-if="showEwalletInfo && $configs.app.isOnePlan">
                  <td>{{ $t('wallet.adjustment.label.WithdrawalAmount') }}</td>
                  <td class="text-uppercase">
                    {{ currencyLabelByCountry }}
                    {{ $helpers.getValue(personalData, 'ewallet.withdraw_cash', 0) | formatPriceDouble }}
                  </td>
                </tr>
                <slot name="tr-bottom"></slot>
              </tbody>
            </q-markup-table>
          </div>
          <div class="col-12">
            <slot></slot>
          </div>
        </div>
        <empty-list v-else :message="emptyMessage" />
      </q-card>
    </div>
  </div>
</template>
<script>
import EmptyList from 'src/application/global/components/common/empty/emptyList'
import { DatesMixin, ScopeConfigMixin } from 'src/application/global/mixins'
import { mapActions, mapGetters, mapState } from 'vuex'
import $configs from '../../../../../config'

export default {
  name: 'MemberPersonalInfo',
  components: {
    EmptyList,
  },
  mixins: [DatesMixin, ScopeConfigMixin],
  props: {
    personalData: {
      type: Object,
    },
    separator: {
      type: String,
      default: 'horizontal',
    },
    bordered: {
      type: Boolean,
      default: false,
    },
    showEwalletInfo: {
      type: Boolean,
      default: false,
    },
    flat: {
      type: Boolean,
      default: true,
    },
    emptyMessage: {
      type: String,
    },
    hideFields: {
      type: Array,
    },
    showFields: {
      type: Array,
    },
    hideCumulativePersonalSales: {
      type: Boolean,
      default: true,
    },
    showSpecialRanks: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    $configs() {
      return $configs
    },
    ...mapState({
      selectedFilters: state => state.globalCMP.selectedFilters,
    }),
    ...mapGetters(['currencyLabelByCountry', 'getBackendConfig', 'getUserTypeId']),
    isMembershipExpired() {
      return this.checkDateValidity(this.$helpers.getValue(this.personalData, 'details.expiry_date', ''))
    },
    getHideFields() {
      return this.hideFields || this.scopeHideFields(null, 'default.info.member', 'array')
    },
    getShowFields() {
      return this.showFields || this.scopeShowFields(null, 'default.info.member', 'array')
    },
  },
  async mounted() {
    await this.getConfigs()
  },
  methods: {
    ...mapActions(['setBackendConfig']),
    hideField(field) {
      return this.getHideFields.includes(field)
    },
    showField(field) {
      return this.getShowFields.includes(field)
    },
    async getConfigs() {
      let payload = {
        user_type: this.getUserTypeId,
        country: this.selectedFilters.countryID,
        lookup: 'member_data_details',
      }
      await this.setBackendConfig(this.$helpers.makeQueryString(payload))
    },
    getMemberRankConfig(rankName) {
      let result = { display: true }
      let config = this.getBackendConfig('member_data_details', 'normalized_value') || []
      if (config.fields && config.fields.length > 0) {
        let fieldConfig = config.fields.find(x => x.key === rankName)
        if (fieldConfig) {
          return ({ result } = fieldConfig)
        }
      }
      return result
    },
  },
}
</script>
